export const adminProfileKeys = {
  base: ["adminProfile"] as const,
  details: () => [...adminProfileKeys.base, "details"] as const,
  practiceList: () => [...adminProfileKeys.base, "practiceList"] as const,
} as const;
